import * as React from "react";
import { useComment } from "../../../../../../utils/reactQuery/cards";
import "./showComments.scss";
import ListComment from "./ListComment";
import Loader from "../../../../../../components/Loader";
import { useCallback, useMemo } from "react";
export default React.memo(function AutoGridNoWrap({ cardId }) {
  const {
    isLoading: isCommentLoading,
    comment,
    isError: isCommentError,
  } = useComment(cardId);

  const sortCommentsByDateDescending = useCallback((comments) => {
    // Check if comments array is defined and not null before sorting
    if (comments && comments.length > 0) {
      return comments.sort(
        (a, b) => new Date(b.comment_time) - new Date(a.comment_time)
      );
    } else {
      return []; // Return an empty array if comments are not defined
    }
  }, []);

  const sortedComments = useMemo(() => 
    sortCommentsByDateDescending(comment?.data?.data?.responseData),
    [comment, sortCommentsByDateDescending]
  );

  return (
    <>
      {isCommentLoading ? (
        <div className="comment-loader">
          <Loader color={"black"} />
        </div>
      ) : (
        sortedComments.map(
          (data,index) => <ListComment key={`show-comment-item-${index}`} data={data} cardId={cardId} />
        )
      )}
    </>
  );
})
